(function (angular) {
    angular.module('bizPartEngage').controller('core.login', loginController);

    loginController.$inject = ["$rootScope", "loginService", "core.forgotpasswordService", "$timeout", "$state", "$window", "bizLoaderService", 
        "$stateParams", "bizValidationService", "$translate", "bizCoreService"];

    function loginController($rootScope, loginService, forgotpasswordService, $timeout, $state, $window, bizLoaderService, 
        $stateParams, bizValidationService, $translate, bizCoreService) {
        var vm = this;
        vm.IsInitialized = false;
        vm.IsImagesInitialized = false;
        vm.BackgroundImage = $rootScope.GetPlatformImageUrl('LoginBackgroundImage');
        vm.REMEMBER_ME_VAL_KEY = "LOGIN_REMEMBER_ME_VAL";
        vm.Message = '';
        vm.ErrorObject = null;
        vm.LoginError = false;
        vm.RememberMe = false;        
        vm.PasswordWasUpdated = false;
        vm.OpenLoginActive = false;
        vm.ShowLogo = $rootScope.MiniSettings.Login.ShowLogo;
        vm.ShowPortalName = $rootScope.MiniSettings.Login.ShowPortalName;
        if ($stateParams.guid === 'init') {
            vm.ActivateAccountInit = true;
        } else {
            vm.ActivateAccountGuid = $stateParams.guid;
        }

        vm.PhraseSuffix = $stateParams.phraseSuffix;

        vm.ParentUnitUrlRewrite = $stateParams.parentUnitUrlRewrite;
        vm.ExternalUnitKey = $stateParams.externalUnitKey;

        if (vm.ParentUnitUrlRewrite) {
            vm.UnitLogo = $rootScope.GetCustomImage('logo');
        }

        console.log("vm.parentUnitUrlRewrite", vm.parentUnitUrlRewrite);
        console.log("vm.ExternalUnitKey", vm.ExternalUnitKey);
        console.log("vm.ActivateAccountInit", vm.ActivateAccountInit)

        vm.Portal;

        vm.Login = Login;
        vm.SetRememberMeData = SetRememberMeData;
        vm.UpdatePassword = UpdatePassword;
        vm.SetHighlightLogin = SetHighlightLogin;
        vm.InitEmailVerification = InitEmailVerification;

        function SetHighlightLogin() {
            setSessionStorage('highlightLogin', 'true');
        }

        function Login() {
            vm.UserName = vm.UserName.trim();
            vm.Password = vm.Password.trim();

            if (vm.UserName.length == 0 || vm.Password.length == 0)
                return;

            bizLoaderService.RequestFullPageLoader();
            if(vm.RememberMe) vm.SetRememberMeData();
            else deleteLocalStorage(vm.REMEMBER_ME_VAL_KEY);

        	loginService.Login(vm.UserName, vm.Password).then(LoginCallback, bizLoaderService.RequestFullPageLoaderFinish);

            function LoginCallback(response) {
                if (response.data.Token && response.data.Token != "") {
                    deleteStorage("BizPartAuthToken");
                    setBizPartAuthToken(response.data.Token, response.data.Id);
                }

                vm.ErrorObject = response.data.Object;

                if (response.data.Id > -1) {
                    if (response.data.RedirectUrl) {
                        if (response.data.RedirectUrl === '/') {
                            $window.location = siteRootPath;
                        } else {
                            $window.location = siteRootPath + response.data.RedirectUrl;
                        }
                        
                    }
                    else if(response.data.HasAdminAccess) {
                        //$window.location = siteRootPath + "admin";
                        $window.location = siteRootPath + $rootScope.MiniSettings.Login.LoginAdminUrl;
                    }   
                    else if (initialUrl) {
                        $window.location = siteRootPath + initialUrl;
                    }
                    else {
                        $window.location = siteRootPath;
                    }    
                }
                else {
                	bizLoaderService.RequestFullPageLoaderFinish();
                    vm.LoginError = true;
                }
            }
        }

        function SetRememberMeData() {
            setLocalStorage(vm.REMEMBER_ME_VAL_KEY, vm.UserName);
        }

        function InitEmailVerification() {
            if (bizValidationService.FormValid(vm.ActivateAccountInitForm) == true) {

                //We can set it right away as the backend will give no indication of success anyway due to security
                vm.AcctivateAccountInitSent = true;
                loginService.InitEmailVerification(vm.InitEmail, vm.ParentUnitUrlRewrite, vm.ExternalUnitKey).then(InitEmailVerificationCallback);

                function InitEmailVerificationCallback(response) {
                    //vm.AcctivateAccountInitSent = true;
                }
            }            
        }

        function UpdatePassword() {
            if (!vm.MyForm2.$valid || vm.Password != vm.RepeatPassword) {

                return;
            }

            //if (bizValidationService.FormValid(vm.MyForm2) == true) { // TODO more validation, regex...?

                //if (vm.Password != vm.RepeatPassword) {
                //    $translate('CORE.FORGOTPASSWORD.PASSWORDNOTSAME').then(function (translation) {
                //        vm.Message = translation || 'Passwords does not match!';
                //    });
                //}
                //else {
                    forgotpasswordService.UpdatePassword(vm.ActivateAccountGuid, vm.Password).then(updateSuccess);

                    function updateSuccess(response) {
                        if (response.data.Success == true) {
                            $translate('CORE.FORGOTPASSWORD.RESETSUCCESS').then(function (translation) {
                                vm.Message = translation || 'Password updated!';
                            });

                            vm.PasswordWasUpdated = true;
                            vm.Password = '';
                            vm.RepeatPassword = '';

                            if (response.data.Object) {
                                if (response.data.Object.redirectUrl) {
                                    vm.RedirectUrl = response.data.Object.redirectUrl;
                                }
                            }
                        }
                        else {
                            vm.Message = response.data.Message;
                        }

                        vm.ErrorObject = response.data.Object;
                    }
               // }
            //}
        }

        function GetInitData() {
            forgotpasswordService.GetBackgroundImage().then(function (response) {
                if (response.length > 0)
                    vm.BackgroundImage = response;

                vm.IsImagesInitialized = true;
            });

            bizCoreService.GetCurrentPortal().then(function(response) {
                vm.Portal = response.data;
            });

            vm.OpenLoginActive = portalSettings["IsOpenIdLoginEnabled"];

            var openIdOnly = portalSettings["IsOpenIdLoginOnly"];
            if (openIdOnly) {
                var overrideOpenIdOnly = getParameterByNameFromUrl('s', location.href) === '91af1798-35b0-4974-9ef5-0fcf52fbe355';
                if (!overrideOpenIdOnly) {
                    vm.OpenIdOnly = true;
                }
            }
        }

        function Init() {

            GetInitData();

            $rootScope.HasAcceptedCookies = getLocalStorage('HasAcceptedCookies');

            if (vm.ActivateAccountGuid) {
                loginService.ActivateAccount(vm.ActivateAccountGuid).then(ActivateAccountCallback);

                function ActivateAccountCallback(response) {
                    console.log(response);
                    vm.Message = response.data.Message;
                    vm.ActivateAccountSuccess = response.data.Success;
                    vm.ErrorObject = response.data.Object;

                    if (response.data.Success && response.data.ExtraInfo?.UserName) {
                        setSessionStorage('ACTIVATED_EMAIL_USERNAME', response.data.ExtraInfo.UserName);
                    } else if (response.data.ExtraInfo?.UserName) {
                        setSessionStorage('ACTIVATED_EMAIL_USERNAME', response.data.ExtraInfo.UserName);
                        $window.location = siteRootPath + $rootScope.MiniSettings["Login"]["AlreadyVerifiedRedirectUrl"];
                    }
                }
            }
            else {
                var rememberMeVal = getLocalStorage(vm.REMEMBER_ME_VAL_KEY);
                var activatedEmailUserName = getSessionStorage('ACTIVATED_EMAIL_USERNAME');
                if (activatedEmailUserName) {
                    deleteSessionStorage('ACTIVATED_EMAIL_USERNAME');
                }

                if (rememberMeVal || activatedEmailUserName) {
                    vm.UserName = rememberMeVal || activatedEmailUserName;
                    if (rememberMeVal) {
                        vm.RememberMe = true;
                    }
                    setTimeout(function () {
                        document.getElementById("password").focus();
                    }, 10);
                } 
            }

            vm.IsInitialized = true;
        }

        vm.$onInit = Init;
    }

})(window.angular);
